/* Theme-level acknowledgement. Shopify-hosted checkout requires separate server-side validation. */
(() => {
  function guard(event, button) {
    const scope = button?.closest('.cart__ctas');
    const checkbox = scope?.querySelector('[data-nd-terms]') ||
      Array.from(document.querySelectorAll('[data-nd-terms]')).find((input) => input.getClientRects().length);
    if (!checkbox || checkbox.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const error = checkbox.closest('.nd-terms').querySelector('[data-nd-terms-error]');
    error.hidden = false;
    checkbox.setAttribute('aria-invalid', 'true');
    checkbox.focus();
  }
  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (button) guard(event, button);
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target.matches('form.cart-form')) guard(event, event.submitter);
  }, true);
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-nd-terms]')) return;
    document.querySelectorAll('[data-nd-terms]').forEach((input) => {
      input.checked = event.target.checked;
      input.removeAttribute('aria-invalid');
      input.closest('.nd-terms').querySelector('[data-nd-terms-error]').hidden = true;
    });
  });
  // Returning from checkout must not silently retain an earlier acknowledgement.
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-nd-terms]').forEach((input) => { input.checked = false; });
  });
})();
